import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Estado } from "./estado.model";
import { HistoricoEstado } from "./historico-estado.model";

export class SolicitacaoDevolucaoHonra extends BaseEntity {

    idOperacao:number;
	cnpjAgenteFinanceiro:string;
	idOperacaoExterno:string;
	sistemaRepasse:string;
	contratoRepasse:string;
	dataEnvio:string;
	comentarioSolicitante:string;
	dataAprovacao:string;
	identificadorCobranca:number;
	estado:Estado;
	usuarioEnvioDevolucao:string;
	valorHonradoARecuperarNaDataDeAprovacao:number;
	historicoEstados:HistoricoEstado[];
	estornoManual: string;
  cestaNumero: number;

}
